import React from "react";
import { useNavigate } from "react-router-dom";
import PaywallModal from "@/components/PaywallModal";
import { useAuth } from "@/context/AuthContext";

// A full-page paywall wrapper (uses the modal styling but no close button).
export default function Paywall() {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    // If already subscribed, bounce to atlas.
    React.useEffect(() => {
        if (user && user.has_access) nav("/atlas");
    }, [user, nav]);

    return (
        <div className="min-h-screen w-full cosmic-sky relative">
            <PaywallModal open={true} onClose={null} reason={null} />
            <button
                onClick={async () => {
                    await logout();
                    nav("/");
                }}
                className="fixed bottom-6 right-6 text-white/80 hover:text-white text-sm font-display font-bold underline"
                data-testid="paywall-sign-out"
            >
                Sign out
            </button>
        </div>
    );
}
